export default __webpack_public_path__ + "static/media/im-icon.5104889e.webp";